import { Utils } from '../utils/utils';
import { Serializable } from './Serializable';

export class MissionDTO extends Serializable {
    id: string;
    actionID: string;
    keyDriverID: string;
    isPersonalized: boolean;
    title: string;
    description: string;
    from: string;
    to: string;
    frequency: number;
    frequencyName: string;
    status: number;
    statusName: string;

    inRisk: boolean;

    resourceURL: string;
    thumbnail: string;
    resourceType: number;
    resourceCategoryID: string;
    resourceCategoryName: string;
    resourceLevel: number;
    resourceLevelName: string;
    //userId: string;



    /**
     * Variable utilizada en front para la seleccion de status en el listado
     */
    statusSelected: any = null;

    constructor() {
        super();
    }

    get fromStr() {
        let date = new Date(this.from);
        return Utils.dateToString(date);
    }

    get toStr() {
        let date = new Date(this.to);
        return Utils.dateToString(date);
    }

    get fromDate() {
        return new Date(this.from);
    }

    get toDate() {
        return new Date(this.to);
    }

    get frequencyNameTranslate() {
        let frequencyNameTranslate = '';
        frequencyNameTranslate = 'ENUMS.DURATION.' + this.frequencyName;
        return frequencyNameTranslate;
    }

}
